//This function returns the correct url depending on whether
//the file was uploaded to the old BO or to the nBO.
//It will be necessary to improve the conditions of
//this function according to the buckets of the BO legacy
export function getWeezFileUrl(value, bucketUrl) {
    if (!value) {
        return null;
    }

    //this pattern seems valid for the forms bucket(Window.weezConfig.aws.weez_bucket_form).
    if (value.startsWith('f_')) {
        return `${bucketUrl}/${value}`;
    }

    return value;
}

export function getModerationAttachmentsUrl(value, bucketUrl) {
    if (!value) {
        return null;
    }

    //this pattern seems valid for the forms bucket(Window.weezConfig.aws.weez_bucket_form).
    if (value.startsWith('f_') || !value.startsWith('https')) {
        return `${bucketUrl}/${value}`;
    }

    return value;
}
